module.exports = __webpack_public_path__ + "img/Logo-White-Square.eccfa401.png";